import styled from 'styled-components';
import { color, fontSize, radius, screen, spacing } from '../../../theme';

export const StyledTeamPicture = styled.figure`
  background-color: ${color('midnight_850')};
  padding: ${spacing('md')};
  border-radius: ${radius('md')};
  margin: 0;
  margin-bottom: ${spacing('lg')};

  @media (min-width: ${screen('md')}) {
    margin-bottom: ${spacing('xl')};
  }

  @media (min-width: ${screen('lg')}) {
    margin-bottom: ${spacing('xl3')};
  }
`;

export const StyledTeamPictureImg = styled.img`
  display: block;
`;

export const StyledTeamPictureCaption = styled.figcaption`
  display: flex;
  color: ${color('text_default_inverse')};
  font-size: ${fontSize('sm')};
  line-height: 1.14;
  margin-top: ${spacing('md')};

  svg {
    color: ${color('emerald_600')};
    margin-right: ${spacing('xs')};
    width: ${spacing('md')};
    height: ${spacing('md')};
  }
`;
